<template>
    <el-dialog title="Hybryder" v-loading="loader" :visible.sync="display" width="90%">
        <div class="mb-3">Hybrider ces produits</div>
        <el-alert v-if="error" :title="errorMessage" type="error" show-icon>
        </el-alert>
        <el-form class="formDeclinaison" ref="form" :model="form">
            <el-table :row-class-name="tableRowClassName" style="width: 100%" ref="multipleTable" :data="form.products" stripe>
                <el-table-column prop="visuel">
                    <template slot-scope="scope">
                        <a v-if="scope.row.images.length" href="#" class="mb-3">
                            <span class="avatar" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.images[0].path+'\')'}"></span>
                        </a>
                    </template>
                </el-table-column>
                <el-table-column prop="shop_id" label="Shop ID">
                </el-table-column>
                <el-table-column prop="name" label="Titre">
                </el-table-column>
                <el-table-column prop="ean13" label="Code barre">
                    <template slot-scope="scope">
                        {{ scope.row.ean13 }}
                    </template>
                </el-table-column>
                <el-table-column prop="mf_prefixe" label="Préfixe fournisseur">
                </el-table-column>
                <el-table-column prop="external_ref" label="Référence fournisseur">
                    <template slot-scope="scope">
                        {{ scope.row.external_ref }}
                    </template>
                </el-table-column>

                <el-table-column label="Infos à garder">
                    <template slot-scope="scope">
                        <el-switch :disabled="!scope.row.datasEditInline.productMaster && hasProductMaster" v-model="scope.row.datasEditInline.productMaster" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { EventBus } from '../../../event-bus';
export default {
    data() {
        return {
            display: false,
            loader: false,
            variationSize: {},
            error: false,
            errorMessage: null,
            form: {
                products: []
            }
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
        hasProductMaster() {
            return this.form.products.filter(
                v => v.datasEditInline.productMaster
            ).length
                ? true
                : false;
        },
        productMaster() {
            return this.form.products.find(
                v => v.datasEditInline.productMaster
            );
        },
        productSpeedwayId() {
            if( this.form.products.length == 1 ) {
                return this.form.products[0].id
            }
            var p = this.form.products.filter(
                v => v.manufacturer_slug == 'speedway'
            );
            if (p.length) {
                return p[0].id;
            }
            return null;
        },
        hasProductVariation() {
            return this.selected.filter(v => v.variationsCount).length
                ? true
                : false;
        },
        countProductVariation() {
            return this.selected.filter(v => v.variationsCount).length;
        },
    },
    methods: {
        open() {
            this.form.products = Array.from(this.selected);

            this.form.products.forEach(v => {
                v.populateEditMode();
            });
            axios.get('/variations/size').then(r => {
                this.variationSize = r.data.data;
                this.display = true;
                this.$store.dispatch('products/setLoader', false);
            });
        },
        action() {
            let datas = { products: [] };
            this.form.products.forEach(v => {
                datas.products.push(v.datasEditInline);
            });
            this.error = false;
            this.errorMessage = null;

            if(!this.productSpeedwayId && datas.products.length == 2){
                this.error = true;
                this.errorMessage = 'Il faut que l\'un des produits soit de fournisseur Speedway.';
                return;
            }

            if (!this.hasProductMaster && datas.products.length == 2) {
                this.error = true;
                this.errorMessage = 'Merci de choisir le produit qui conservera les informations.';
                return;
            }

            if (datas.products.length == 2) {
                var sameShopId  = datas.products[0].shop_id == datas.products[1].shop_id;
                var sameBaseRef = (datas.products[0].base_ref && datas.products[1].base_ref ) &&  datas.products[0].base_ref == datas.products[1].base_ref && datas.products[0].mf_prefixe == datas.products[1].mf_prefixe;

                if( (!sameShopId && !sameBaseRef) && datas.products[0].external_ref != datas.products[1].external_ref){
                    this.error = true;
                    this.errorMessage = 'Ces produits n\'ont pas la meme reference fournisseur.';
                    return;
                }
            }
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            this.$confirm('Hybrider ces produits ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    this.loader = true;
                    axios
                        .post(
                            '/products/' +
                                this.productSpeedwayId +
                                '/hybrid',
                            datas
                        )
                        .then(r => {
                            this.form.products = [];
                            this.display = false;
                            EventBus.$emit('products.list.refresh');
                        })
                        .catch((r) => {
                            this.error = true;
                            var message = r.response.data.message || r.message;
                            this.errorMessage = message;
                        })
                        .then(() => {
                            this.loader = false;
                        });
                })
                .catch(() => {});
        },
        cancelEditMode() {
            this.form.products.forEach(v => v.cancelEditMode());
        },
        variationSizeAlreadySelected(variationSize) {
            if (
                this.productMaster &&
                this.productMaster.variationsCount &&
                this.productMaster.variationsIds.find(
                    v => v == variationSize.id
                )
            ) {
                return true;
            }

            return this.form.products.filter(
                v => v.datasEditInline.variation_value_id == variationSize.id
            ).length
                ? true
                : false;
        },
        tableRowClassName({ row, rowIndex }) {
            var c  = 'manufacturer-' + row.manufacturer_slug;
            if (
                this.hasProductMaster &&
                !row.datasEditInline.productMaster &&
                row.variationsCount
            ) {
                c += ' warning-variation-already ';
            }
            return c;
        },
        edit(product) {
            product.setEditMode();
        },
        save(product) {
            var datas = product.saveEditMode();
            //variation.inlineLoader = true;
        }
    }
};
</script>
